/*
Copyright Captcha, Inc. 2004-2021. All rights reserved.

BotDetect, BotDetect CAPTCHA, Lanap, Lanap CAPTCHA, Lanap BotDetect, 
Lanap BotDetect CAPTCHA, Lanapsoft, Lanapsoft CAPTCHA, 
Lanapsoft BotDetect, Lanapsoft BotDetect CAPTCHA, and Lanap Software 
are trademarks of Captcha, Inc. All other product, brand, and company 
names are mentioned for identification purposes only and are trademarks 
or registered trademarks of their respective owners.

Captcha, Inc. - formerly: Lanapsoft, Inc. / Lanap, Inc.
*/

import { isEmptyObject } from './object';

function setRequestHeaders(xhr, httpHeaders) {
  if (!isEmptyObject(httpHeaders) && xhr.setRequestHeader) {
    for (let attr in httpHeaders) {
      if (httpHeaders.hasOwnProperty(attr)) {
        xhr.setRequestHeader(attr, httpHeaders[attr]);
      }
    }
  }
}

export default function httpGet(url, httpHeaders, callback) {
  const xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function() {
    if ((xhr.readyState === 4) && (xhr.status === 200)) {
      if (typeof callback === 'function') {
        callback(xhr.responseText);
      }
    }
  };
  xhr.open('GET', url, true);
  setRequestHeaders(xhr, httpHeaders);
  xhr.send();
}
